import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeader } from "./Section";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogPreview({ compact = false }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  return (
    <section data-testid="blog-section" className="relative py-24 md:py-32 bg-brand-sand">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {!compact && (
          <SectionHeader
            overline="Ressources et conseils"
            title="Le blog OPTINA."
            subtitle="Des guides pratiques pour comprendre le marché, prendre les bonnes décisions, et payer le juste prix."
          />
        )}

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {items.map((a, i) => (
            <Reveal key={a.slug} delay={i}>
              <Link
                data-testid={`blog-card-${a.slug}`}
                to={`/blog/${a.slug}`}
                className="card-lift group block bg-white rounded-2xl border border-brand-border overflow-hidden"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={a.image}
                    alt={a.image_alt || a.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="absolute top-4 left-4 bg-white/95 backdrop-blur px-3 py-1.5 rounded-full overline text-brand-ink">
                    {a.category}
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="font-serif text-[26px] leading-[1.15] tracking-tight text-brand-ink">
                    {a.title}
                  </h3>
                  <p className="mt-4 text-brand-ink/65 text-[15px] leading-relaxed">{a.extract}</p>
                  <div className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-brand-gold tracking-[0.08em] uppercase">
                    Lire l'article <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
